import React, { PropsWithChildren } from 'react';
import { infoBarStyles } from '../../constants/theme/styles/components/infoBar';


interface Props {
    breadcrumbWrapper?: boolean
}
export const InfoBarWrapper = (props: PropsWithChildren<Props>) => {
    const infoBarClasses = infoBarStyles();
    return (
        <div className={infoBarClasses.infoBarWrapper}>
            <div className={props.breadcrumbWrapper ? 'breadcrumbs-inner' : 'infobar-inner'}>
                {props.children}

            </div>
        </div>
    );
};

InfoBarWrapper.defaultProps = {
    breadcrumbWrapper: false,
};